import React, { useState, useEffect } from 'react';
import { AiFillEye, AiFillGithub } from 'react-icons/ai';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Work.scss';
const Work = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 }); //initially set the animate card to an object with y:0 and opacity:1
  const [works, setWorks] = useState([]); //initially set the works to an empty array
  const [filterWork, setFilterWork] = useState([]); //initially set the filterWork to an empty array

  useEffect(() => {
    const query = '*[_type == "works"]';
    client.fetch(query)
      .then((data) => {
        setWorks(data);
        setFilterWork(data);
      })

  }, [])


  const handleWorkFilter = (item) => {
    //takes an item as an argument and set the active filter to that item, basically be able to filter the work based on the tags like UI/UX, Web App, Mobile App, React JS, All

    setActiveFilter(item);
    setAnimateCard({y:100, opacity:0}); //set the animate card to an object with y:100 and opacity:0

    setTimeout(() => {
      //this function will be called after 500ms

      setAnimateCard({y:0, opacity:1}); //set the animate card to an object with y:0 and opacity:1

      if(item === 'All'){
        setFilterWork(works);
      }else{
        //filtering the work array based on the tags
        setFilterWork(works.filter((works)=>works.tags.includes(item)));
      }
    },500)


  }
  return (
    <>

      <h2 className='head-text'>My Creative <span>Portfolio</span> Section </h2>

      <div className='app__work-filter'>
        {/*here we can loop over all the categories   */}
        {['Web App', 'IoT', 'DSA', 'C/C++', 'Compiler Design', 'DBMS', 'All'].map((item, index) => (
          <div key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${activeFilter === item ? 'item-active' : ''}`}>

            {item}

          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard} //animateCard stores the state of the card wrt its y and opacity
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='app__work-portfolio'>
        {/*loop over the portfolio items */}
        {filterWork.map((work, index) => (

          <div className="app__work-item app__flex" key={index}>
            <div
              className="app__work-img app__flex"
            >
              <img src={urlFor(work.imgUrl)} alt={work.name} />

              <motion.div
                initial={{ opacity: 0 }}  // Ensures it starts with no hover effect
                whileHover={{ opacity: 1 }}  // Shows the overlay when hovered
                transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}
                className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">

                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.90] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text" style={{ marginTop: 10 }}>{work.description}</p>

              <div className="app__work-tag app_flex">
                {/* render the first tag */}
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}

      </motion.div>

    </>
  );

};

export default AppWrap(
  
  MotionWrap(Work,'app__works'), 'work','app__primarybg'

);
